import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import { Tooltip, Typography } from '@mui/material';
import { Chip } from '@mui/material';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faEdit, faPlay, faStop, faThList, faTicket, faTrash } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';

import UserContext from '../../../../navigation/context/userContext';

//export default class TablaProductos extends Component
export default function EconomiesDataTable({economies,onRefresh})
{
    const {userData,setUserData} = useContext(UserContext)
    //const [economies,setEconomies] = useState([]);
    //const [isLoading,setIsLoading] = useState(false);


    const columns = [
        {
            name : 'name',
            label : 'Economia',
            options : 
            {
                filter:false,
                searchable:true
            }
        },
        {
            name : 'mode',
            label : 'Modo',
            
            options:{
                filter:true,
                searchable:true
            }
        },
        {
            name : 'technology',
            label : 'Tecnología',
            options:{
                filter:true,
                //filterType:'dropdown',
                display:true,
                searchable:true
            }
        },
        {
            name : 'currency',
            label : 'Moneda',
            
            options:{
                filter:true
            }
        },
        {
            name : 'type',
            label : 'Uso',
            
            options:{
                filter:false
            }
        },
        {
            name : 'status',
            label : 'Estatus',
            options : 
            {
                customBodyRender : (value, tableMeta, updateValue) => (
                    value === 'active'
                    ? <Chip label='Activo' color='success'/>
                    : <Chip label='Inactivo' color='error' />
                )            
            }
        },
        {
            name : '',
            label : 'Acciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = subCategorias[dataIndex].idSubCategoria;
                    return(
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                            <Link 
                                //onClick = { () => handleChangeStatus(economies[dataIndex].id)  }  
                            >
                                <IconButton>
                                {
                                    economies[dataIndex].status === 'active'
                                    ? 
                                    <Tooltip title='Inactivar' placement="top">
                                        <FontAwesomeIcon icon={faStop}/>
                                    </Tooltip>
                                    :
                                    <Tooltip title='Activar' placement="top">
                                        <FontAwesomeIcon icon={faPlay}/>
                                    </Tooltip>
                                }
                                </IconButton>
                            </Link>

                            
                            <Link 
                                to={'/economies/update/'+economies[dataIndex].id} 
                                //onClick={ ()=> localStorage.setItem('evento',JSON.stringify(economies[dataIndex])) }
                                replace
                            >
                                <Tooltip title='Editar' placement='top'>
                                    <IconButton>
                                        <FontAwesomeIcon icon={faEdit}/>
                                    </IconButton>
                                </Tooltip>
                            </Link>

                            <Link 
                                to={'/cashless/economies/details/'+economies[dataIndex].uuid} 
                                //onClick={ ()=> localStorage.setItem('evento',JSON.stringify(economies[dataIndex])) }
                                replace
                            >
                                <Tooltip title='Detalles' placement='top'>
                                    <IconButton>
                                        <FontAwesomeIcon icon={faClipboardList}/>
                                    </IconButton>
                                </Tooltip>
                            </Link>
                        </div>
                    );
                },

                filter:false,
                print:false
            }
        }
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
      };


    return(
        <>
            <MUIDataTable
            
                title={"Listado de Economias"}
                data={economies}
                columns={columns}
                options={options}
            />
        </>
    )
}